import { hex2rgb, rgb2hex } from "@pixi/utils";
import { Tween } from "@westpierstudio/luma/createjs";
import { clone, cloneDeep } from "lodash";
import { Sprite, Texture } from "pixi.js";
import { JackpotSpec } from "./Jackpot";

export class JackpotRect extends Sprite {
    private _currentRgb: (Float32Array | number[]);
    private rgbCol1: (Float32Array | number[]);
    private rgbCol2: (Float32Array | number[]);
    private rgbCol3: (Float32Array | number[]);
    private targetAlpha: number = 0;
    private tweenDuration: number = 0;

    public get r(): number {
        return this._currentRgb[0];
    }
    public set r(value: number) {
        this._currentRgb[0] = value;
    }
    public get g(): number {
        return this._currentRgb[1];
    }
    public set g(value: number) {
        this._currentRgb[1] = value;
    }
    public get b(): number {
        return this._currentRgb[2];
    }
    public set b(value: number) {
        this._currentRgb[2] = value;
        this.tint = rgb2hex(this._currentRgb);
    }

    constructor(symbolSize: { width: number; height: number; }, pos: { x: number; y: number; }, colour: number[], spec: JackpotSpec) {
        super();
        this.texture = Texture.WHITE;
        this.anchor.x = 0.5;
        this.width = symbolSize.width;
        this.position = pos;
        this.targetAlpha = spec.alpha;
        this.tweenDuration = spec.tweenDuration;
        this.alpha = 0;
        this.tint = colour[0];
        this.rgbCol1 = hex2rgb(colour[0]);
        this.rgbCol2 = hex2rgb(colour[1]);
        this.rgbCol3 = hex2rgb(colour[2]);
        this._currentRgb = clone(this.rgbCol1);
    }

    startAnimation() {
        this._currentRgb = clone(this.rgbCol1);
        Tween.get(this)
            .to({ r: this.rgbCol2[0], g: this.rgbCol2[1], b: this.rgbCol2[2] }, this.tweenDuration)
            .to({ r: this.rgbCol3[0], g: this.rgbCol3[1], b: this.rgbCol3[2] }, this.tweenDuration)
            .to({ r: this.rgbCol1[0], g: this.rgbCol1[1], b: this.rgbCol1[2] }, this.tweenDuration)
            .loop = -1;
        Tween.get(this)
            .to({ alpha: this.targetAlpha }, this.tweenDuration);

    }

    stopAnimation() {
        Tween.get(this)
            .to({ alpha: 0 }, this.tweenDuration)
            .call(() => Tween.removeTweens(this));
    }
}
